export const replaceSpacesWithDashes = (text = '') => text.replace(/ /g, '-')
